import { styled, Stack, shape, withUtility, css } from '@hub-la/design-system';
import { keyframes, alpha } from '@mui/material';

let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4;
const backgroundWave = keyframes(_t || (_t = _`
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 50% 100%;
  }

  100% {
    background-position: 0% 50%;
  }
`));
const Wrapper = styled(Stack)(_t2 || (_t2 = _`
  width: 100%;
  overflow: hidden;
  border-radius: ${0};
  ${0}
`), shape('medium'), withUtility(({
  palette
}, {
  started
}) => {
  if (started) {
    return css(_t3 || (_t3 = _`
        background: linear-gradient(104.83deg, #d8fd6c 0%, #dde2fe 20.9%, #79fbac 100%);
        background-size: 400% 400%;
        animation: ${0} 5s ease infinite;
        border: 4px solid transparent;
      `), backgroundWave);
  }
  return css(_t4 || (_t4 = _`
      background: transparent;
      border: 1px solid ${0};
    `), alpha(palette('onSurface'), 0.2));
}));

export { Wrapper };
